import { useHotkeys } from "react-hotkeys-hook";
import { useTaskStore } from "../stores/taskStore";
import { useUiStore } from "../stores/uiStore";

export function useFlowShortcuts() {
  const setEditorOpen = useUiStore((s) => s.setEditorOpen);
  const setSettingsOpen = useUiStore((s) => s.setSettingsOpen);
  const setShortcutsOpen = useUiStore((s) => s.setShortcutsOpen);
  const editorOpen = useUiStore((s) => s.editorOpen);
  const settingsOpen = useUiStore((s) => s.settingsOpen);
  const shortcutsOpen = useUiStore((s) => s.shortcutsOpen);
  const voiceOpen = useUiStore((s) => s.voiceOpen);
  const setSearch = useTaskStore((s) => s.setSearch);
  const setFilter = useTaskStore((s) => s.setFilter);
  const undoDelete = useTaskStore((s) => s.undoDelete);
  const setAppView = useUiStore((s) => s.setAppView);
  const modalOpen = editorOpen || settingsOpen || shortcutsOpen || voiceOpen;

  useHotkeys("meta+n", (e) => { e.preventDefault(); if (!modalOpen) setEditorOpen(true); });
  useHotkeys("meta+f", (e) => { e.preventDefault(); if (!modalOpen) document.querySelector<HTMLInputElement>('input[placeholder="検索"]')?.focus(); });
  useHotkeys("meta+1", () => { if (!modalOpen) setAppView("command"); });
  useHotkeys("meta+2", () => { if (!modalOpen) { setAppView("tasks"); void setFilter("today"); } });
  useHotkeys("meta+3", () => { if (!modalOpen) { setAppView("tasks"); void setFilter("active"); } });
  useHotkeys("meta+4", () => { if (!modalOpen) { setAppView("tasks"); void setFilter("all"); } });
  useHotkeys("meta+5", () => { if (!modalOpen) { setAppView("tasks"); void setFilter("high"); } });
  useHotkeys("meta+,", (e) => { e.preventDefault(); if (!modalOpen) setSettingsOpen(true); });
  useHotkeys("?", () => { if (!modalOpen) setShortcutsOpen(true); });
  useHotkeys("esc", () => {
    if (editorOpen) setEditorOpen(false);
    else if (settingsOpen) setSettingsOpen(false);
    else if (shortcutsOpen) setShortcutsOpen(false);
    else void setSearch("");
  });
  useHotkeys("meta+z", (e) => { e.preventDefault(); if (!modalOpen) void undoDelete(); });
}
